import React, { useEffect } from 'react';
import styled, { StylesProps, cx } from '../../../lib/styles';
import holidaySectionStyles from './HolidaysBlock_styles';
import { Holiday as HolidayModel } from '../../../models/holiday';
import Typography from '../Typography';
import Button from '../Button';
import Holiday from '../Holiday';
import FeaturedHoliday from '../Holiday/FeaturedHoliday';
import Ad, { Ad as AdData } from '../Ad';
import { isArray } from 'util';
import Spacer from '../Spacer';
import { BaseBlockProps } from '../../../models/travelCollection';

export interface HolidaysBlockProps extends BaseBlockProps {
  className?: string;
  feature?: boolean;
  holidays: HolidayModel[];
  title?: string;
  subtitle?: string;
  description?: string;
  hasMore?: boolean;
  isLoading?: boolean;
  onShowMore?: () => any;
  showMoreText?: string;
  lazy: boolean;
  onClick?: (holiday: HolidayModel) => any;
  topAd?: AdData;
  columns?: number;
}

const HolidaysBlock = ({
  className,
  holidays,
  feature = false,
  isLoading = false,
  title,
  subtitle,
  description,
  hasMore = false,
  onShowMore,
  onClick,
  styles,
  topAd,
  lazy,
  showMoreText = 'Show me more holidays',
  isV2Collection = false,
}: HolidaysBlockProps & StylesProps<typeof holidaySectionStyles>) => {

  // useEffect(() => {
  //   console.log('HolidaysBlock holidays', holidays);
  // }, [holidays]);
    
  return (
    <>
      {holidays.length > 0 && (
        <div className={cx('HolidaysBlock', styles.container, className, (isV2Collection ? `v2-collection-block` : null))}>
          {topAd && <Ad ad={topAd} initialSize={[300, 90]} />}

          {(title || subtitle || description) && (
            <div className={styles.heading}>
              <div>
                {title && (
                  <Typography>
                    <h1 id={`${title.stripSpecialCharacters().replaceSpaces('-').toLowerCase()}`}>{title}</h1>
                  </Typography>
                )}
              </div>

              {description && (
                <Typography weight={'normal'} className='my-0'>
                  <h3
                    dangerouslySetInnerHTML={{ __html: description }}
                  />
                </Typography>
              )}
            </div>
          )}

          <div className={styles.holidaysContainer}>
            {feature && isArray(holidays) && holidays.length > 0 && (
              <FeaturedHoliday
                lazy={lazy}
                holiday={holidays[0]}
                onClick={() => onClick && onClick(holidays[0])}
              />
            )}

            <div className={styles.holidays}>
              {isArray(holidays) &&
                holidays
                  .slice(feature ? 1 : 0)
                  .map((holiday: HolidayModel, i: number) => (
                    <div key={i} className={styles.holiday}>
                      <Holiday
                        lazy={lazy}
                        holiday={holiday}
                        onClick={() => onClick && onClick(holiday)}
                      />
                    </div>
                  ))}
            </div>

            {hasMore && (
              <Spacer align={'center'}>
                <Button
                  color={'light_grey'}
                  onClick={() => !isLoading && onShowMore && onShowMore()}
                  disabled={isLoading}
                >
                  {isLoading && <div className={styles.loading} />}
                  {!isLoading && showMoreText}
                </Button>
              </Spacer>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default styled(holidaySectionStyles)(HolidaysBlock);
